import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOrderGetByIdQuery } from 'api/generated/graphql';
import { parseOrderEntity, useError } from 'api/helpers';

export const useOrderGetById = (id: string) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetByIdQuery({ variables: { id } });

  const error = useError(apolloError);

  const order = useMemo(
    () => (data?.order ? parseOrderEntity(data.order) : null),
    [data?.order]
  );

  return {
    order,
    loading,
    error,
  };
};
